import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { EngagementDetails } from '@/types/module.types';
import { ICONS } from '@ui/icons/types';

import Link from '@ui/links/link';
import Icon from '@ui/icons/icon';
import { Activity } from 'react';

type EngagementCardProps = {
  engagementDetails: EngagementDetails;
  baseUrl: string;
  engagementCount?: number;
};

const EngagementCard = ({ engagementDetails, baseUrl, engagementCount = 0 }: EngagementCardProps) => {
  return (
    <Link
      to={`${baseUrl}${engagementDetails.linkPartial ? engagementDetails.linkPartial : ''}`}
      backgroundColor="transparent"
    >
      <Container
        className="flex fd-column jc-space-between padding-v-20 padding-h-24 radius-12"
        height="140px"
        width="320px"
        gradientOverlay={{
          height: '100%',
          width: '100%',
          background: engagementDetails.gradientBg,
          borderRadius: '12px',
        }}
        background="transparent"
      >
        <Container className="flex fd-row jc-space-between">
          <Container
            className="flex fd-row radius-100 padding-v-4 padding-r-12 padding-l-10 ai-center gap-4"
            background={`var(${engagementDetails.color}`}
          >
            <Icon name={engagementDetails.icon || ''} size={12} color={engagementDetails.labelFontColor} />
            <Container className="L2" style={{ color: engagementDetails.labelFontColor }}>
              {engagementDetails.label}
            </Container>
          </Container>
          <Activity mode={engagementCount > 0 ? 'visible' : 'hidden'}>
            <Container
              className="flex fd-row radius-100 padding-v-4 padding-r-12 padding-l-10 ai-center gap-4"
              background={engagementDetails.countBg}
            >
              <Icon name={ICONS.ARROW_BIG_TURN_RIGHT} size={12} />
              <Text className="L2">{engagementCount}</Text>
            </Container>
          </Activity>
        </Container>
        <Container>
          <Text className="H5" clamp={2}>
            {engagementDetails.title}
          </Text>
        </Container>
      </Container>
    </Link>
  );
};

export default EngagementCard;
